<script>
  import {
    apiServiceSendGoodsMsg,
    getGoodsInfoById
  } from '@/api/app';
  import {Message} from "element-ui";
  export default {
    name:"TuijianGoods",
    data(){
      return {
        goodsInfo:{},
        visible:false,
      }
    },
    watch:{
      async value(val){
        console.log("当前对话类型",this.type);

        this.visible = val;
        if(val===false || this.goodsId==='' || this.goodsId==null ) {
          this.clearDatas();
          return val;
        }
        const res = await getGoodsInfoById({
          goods_id: this.goodsId
        })
        if (res.success === false) {
          Message({type: 'error', message: "未找到该商品"});
        } else {
          this.goodsInfo = res
        }
      }
    },
    props:{
      goodsId:{
        default:null,
        type:[String,Number]
      },
      value:{
        default: false,
        type:Boolean
      },
      toId:{
        default:null,
        type:[Number,String]
      },
      type:{
        default:null,
        type:[Number,String]
      }
    },
    async mounted() {
    },
    methods:{
      async sendGoodsById(id) {
        await apiServiceSendGoodsMsg({
          goods_id: id,
          user_id: this.toId,
          chat_type:this.type
        })
        this.$message({
          type: 'success',
          message: '发送成功!'
        });
        this.goodsInfo = {};
        this.$emit("close");
      },
      clearDatas(){
        this.goodsInfo = {};
        this.$emit("close");
      }
    }
  }
</script>

<template>
  <!--弹窗-->
  <el-dialog title="商品信息"
             :visible.sync="visible"
             width="400px"
             @close="clearDatas"
  >
    <div class="dialogGoods">
      <div class="order-goods flex col-top">
        <div class="flex-none">
          <el-image fit="cover" :src="goodsInfo.thumb" style="width: 68px;height: 68px;"></el-image>
        </div>
        <div class="flex-1 m-l-8" style="min-width: 0">
          <div class="goods-name line-4">{{ goodsInfo.name }}</div>
          <div class="muted m-t-5">{{ goodsInfo.spec_value_str }}</div>
        </div>
      </div>
      <div class="order-con">
        <div class="m-t-15">
          <span class="muted">游戏名称：</span>
          <span>{{ goodsInfo.category_name }}</span>
        </div>

        <div class="m-t-15">
          <span class="muted">游戏区服：</span>
          <span>{{ goodsInfo.qufu }}</span>
        </div>

        <div class="m-t-15">
          <span class="muted">商品金额：</span>
          <span style="color: red">{{ goodsInfo.price }}</span>
        </div>

        <div class="m-t-15" style="text-align: center;">
          <el-button @click="sendGoodsById(goodsInfo.id)" type="danger" class="btn-send" size="mini">发送商品链接</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<style scoped lang="scss">
.dialogGoods {
  .order-list {
    font-size: 12px;

    .order-item {
      padding: 20px 0;

      &:not(:last-of-type) {
        border-bottom: 1px solid #f5f5f5;
      }

      .order-status {
        padding: 2px 9px;
        border-radius: 12px;
        background: #ebf1ff;
        color: #4073fa;

        &.wait-pay {
          color: #ff2c3c;
          background: rgba(255, 44, 60, 0.08);
        }
      }
    }
  }
}
</style>